import {useEnvironment} from '@wix/yoshi-flow-editor'
import React from 'react'
import {TPAComponentsProvider} from 'wix-ui-tpa/cssVars'
import {ErrorPage} from '../../../../../commons/components/error-page'
import {RuntimeContext} from '../../../../../commons/components/runtime-context/runtime-context'
import {DatesProvider} from '../../../../../commons/hooks/dates'
import {StylesForAllBreakpointsProvider} from '../../../../../commons/hooks/styles-for-all-breakpoints'
import {usePrevious} from '../../../../../commons/hooks/use-previous'
import {MemberAppProps} from '../../../interface'
import {AppContainer} from '../app-container'

export const App = (props: MemberAppProps) => {
  const {state, isRTL, host, actions, isRendered} = props
  const {isMobile, isPreview} = useEnvironment()
  const prevFormFactor = usePrevious(host.formFactor)

  React.useEffect(() => {
    if (actions && host && state) {
      if (isPreview && host.formFactor !== prevFormFactor) {
        actions.setFormFactor(host.formFactor)
      }
    }
  }, [host.formFactor])

  if (!state) {
    if (!isRendered) {
      return null
    }
    return <ErrorPage viewMode={host.viewMode} />
  }

  return (
    <RuntimeContext.Provider value={props}>
      <TPAComponentsProvider value={{mobile: isMobile}}>
        <DatesProvider dates={state.dates}>
          <StylesForAllBreakpointsProvider>
            <AppContainer isRTL={isRTL} />
          </StylesForAllBreakpointsProvider>
        </DatesProvider>
      </TPAComponentsProvider>
    </RuntimeContext.Provider>
  )
}
